export default __webpack_public_path__ + "static/media/dancing_pickle.cfc9ebed.gif";